"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadFolderOperation = void 0;
/** Upload multiple files to IPFS and place them in a folder directory. */
exports.uploadFolderOperation = {
    method: 'POST',
    name: 'uploadFolder',
    id: 'uploadFolder',
    groupName: 'ipfs',
    urlPathPattern: '/ipfs/uploadFolder',
    bodyType: 'raw',
    bodyParamNames: ['abi'],
    getRequestUrlParams: getRequestUrlParams,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
    deserializeResponse: deserializeResponse,
    getRequestBody: getRequestBody,
};
// Methods
function getRequestUrlParams(_) {
    return {};
}
function getRequestBody(request) {
    return request.abi;
}
function deserializeResponse(jsonResponse) {
    return jsonResponse;
}
function serializeRequest(request) {
    return {
        abi: JSON.stringify(request.abi),
    };
}
function deserializeRequest(jsonRequest) {
    return {
        abi: JSON.parse(jsonRequest.abi),
    };
}
//# sourceMappingURL=uploadFolderOperation.js.map